import React from 'react';
import styled from 'styled-components';

import IconContainer from 'LegacyWeployDesignLanguage/icons/IconContainer';
import ThumbUpSvg from 'LegacyWeployDesignLanguage/icons/ThumpUpIcon';

const EmptyOpenJobsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledIconContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing[3]};
`;

const EmptyOpenJobs = () => (
  <EmptyOpenJobsWrapper>
    <StyledIconContainer>
      <IconContainer svg={<ThumbUpSvg />} size={IconContainer.MEDIUM} />
    </StyledIconContainer>
    <span>Nice, all open jobs have been filled!</span>
  </EmptyOpenJobsWrapper>
);

export default EmptyOpenJobs;
